import React, { FocusEvent, ChangeEvent, useState } from 'react';
import Icon from '../../../../@shared/icon';
import { RichText } from '@sitecore-jss/sitecore-jss-react';
import { iconSize } from '../../../../../constants/icon.constants';

function MarketingConsentCheckbox(props) {
  const { field, tracker } = props;
  const id = field.valueField.id;
  const name = field.valueField.name;
  const [isChecked, setIsChecked] = useState(false);
  const onFocus = (e: FocusEvent<HTMLInputElement>): void => {
    tracker.onFocusField(field, e?.target?.value);
  };

  const onBlur = (e: FocusEvent<HTMLInputElement>): void => {
    tracker.onBlurField(field, e?.target?.value);
  };

  const onChange = (e: ChangeEvent<HTMLInputElement>): void => {
    setIsChecked(e?.target?.checked);
    props.onChange(name, ('checkbox' + '|' + e?.target?.checked) as string, props.isValid, []);
  };

  return (
    <>
      <input
        id={id}
        name={name}
        className="sitecore-jss-form__field"
        onFocus={onFocus}
        onBlur={onBlur}
        type="checkbox"
        onChange={onChange}
        value={props.value}
        checked={isChecked}
        form="novalidatedform"
      />
      <label htmlFor={id} className="sitecore-jss-form__control__label--checkbox-label">
        <Icon
          iconName={isChecked ? 'action-checkbox-checked' : 'action-checkbox-default'}
          size={iconSize.dsk}
          extraClassName="sitecore-jss-form__checkbox"
        />
        <RichText tag="span" field={{ value: field?.model?.marketoConsentValue }} className="rich-text" />
      </label>
    </>
  );
}

export default MarketingConsentCheckbox;
